import { Box, Heading, HStack, SimpleGrid } from "@chakra-ui/layout";
import { useTranslation } from "react-i18next";
import { companyColors } from "../../../global/companyColors";
import { MaxWidthContainer } from "../../../generic/layout/maxWidthContainer";
import {
  Text,
  List,
  ListItem,
  ListIcon,
  Divider,
  VStack,
  Link,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Image,
  Alert,
  AlertIcon,
  Badge,
  Icon,
} from "@chakra-ui/react";
import {
  CheckCircleIcon,
  InfoOutlineIcon,
  ExternalLinkIcon,
  TimeIcon,
  EmailIcon,
  CalendarIcon,
  WarningIcon,
} from "@chakra-ui/icons";
import { HeadingMedium } from "../../../generic/layout/headingMedium";
import { TextHeading } from "../../team/EmployeeDetails";
import Win_AudioSettings from "./media/Win_AudioSettings.png";
import MacOs_AcceptPluggedInDevice from "./media/MacOs_AcceptPluggedInDevice.png";
import MacOs_AudioSettings from "./media/MacOs_AudioSettings.png";
import MicSetupImage from "./media/MicSetup.png";
import ShureMv6Product from "./media/ShureMv6Product.png";
import All_Riverside_Welcome from "./media/All_Riverside_Welcome.png";
import All_Riverside_Join from "./media/All_Riverside_Join.png";
import Win_Riverside_StartAllowAccess from "./media/Win_Riverside_StartAllowAccess.png";
import Win_Riverside_AllowAccess from "./media/Win_Riverside_AllowAccess.png";
import MacOs_Riverside_AllowAccess from "./media/MacOs_Riverside_AllowAccess.png";
import MacOs_Riverside_StartAllowAccess from "./media/MacOs_Riverside_StartAllowAccess.png";
import Win_AudioSettings_Pegel from "./media/Win_AudioSettings_Pegel.png";
import Win_AudioSettings_DeviceSettings from "./media/Win_AudioSettings_DeviceSettings.png";

export function PodcastTechInstructionsComponent() {
  const { t } = useTranslation();
  return (
    <MaxWidthContainer py={8}>
      <HeadingMedium mb={4}>
        {t("Anleitung für die Vorbereitung auf Ihr Interview")}
      </HeadingMedium>
      <MicrophoneSetupArticle />
    </MaxWidthContainer>
  );
}

const MicrophoneSetupArticle = () => {
  return (
    <VStack align="unset" spacing={4} pt={0} mt={0}>
      <Box>
        Diese Anleitung führt Sie Schritt für Schritt durch die Einrichtung des
        Mikrofons, die technischen Konfiguration unter Windows oder macOS und
        bereitet Sie optimal auf Ihre Audioaufnahmen vor, um einen reibungslosen
        Ablauf und die bestmögliche Aufnahmequalität zu gewährleisten.
      </Box>
      <Box>
        <TextHeading mt={4} text={"1. Vorbereitung und Aufnahmebedingungen"} />
        <VStack spacing={2} ml={1} alignItems="unset">
          <MyListItem>
            Wählen Sie einen ruhigen Raum mit möglichst wenig
            Hintergrundgeräuschen und wenig Hall, um optimale Aufnahmequalität
            zu gewährleisten.{" "}
          </MyListItem>
          <MyListItem>
            Stellen Sie das Mikrofon auf einen festen Tisch.{" "}
          </MyListItem>
          <MyListItem>
            Halten Sie stets ca. eine Faustbreite Abstand zum Mikrofon. Bitte
            beachten Sie, dass Geräusche wie Tastaturtippen oder andere
            Aktivitäten auf dem Tisch als Vibrationen an das Mikrofon übertragen
            werden können.
          </MyListItem>
          <Divider />
          <MyListItem icon={ExternalLinkIcon}>
            Prüfen Sie Ihre Verbindung auf{" "}
            <Link href="https://www.fast.com" isExternal color="teal.500">
              www.fast.com
            </Link>
          </MyListItem>
          <MyListItem>
            Mindestens 10 Mbps Upload & Download ist empfohlen.
          </MyListItem>
          <MyListItem>
            Latency (sichtbar beim Klick auf "Show more info") unter 50 ms
            ideal.
          </MyListItem>
        </VStack>
      </Box>
      <Box>
        <TextHeading text={"2. Mikrofon zusammenbauen und anschließen"} />
        <SimpleGrid
          templateColumns={{ base: "1fr", md: "1fr 1fr" }}
          flexDirection="column-reverse"
          spacing={8}
          justifyContent="space-between"
        >
          <Image
            src={ShureMv6Product}
            maxWidth={{ base: "100%", md: "100%" }}
            mb={2}
            mt={4}
            alt="Shure MV6 USB Mikrofon"
            justifySelf={{ base: "unset", md: "center" }}
          />
          <VStack spacing={2} ml={1} alignItems="unset" mt={{ base: 0, md: 4 }}>
            <MyListItem>Packen Sie das Shure MV6 USB Mikrofon aus. </MyListItem>
            <MyListItem>
              Verschrauben Sie das Stativ mit dem Mikrofon, sodass es stabil
              steht.{" "}
            </MyListItem>
            <MyListItem>
              Schließen Sie das USB-C-Kabel an das Mikrofon an.{" "}
            </MyListItem>
            <MyListItem>
              Verbinden Sie das Kabel direkt mit Ihrem Computer.
              <VStack spacing={2} fontSize={"xs"} mt={2} alignItems={"unset"}>
                <HStack alignItems={"start"}>
                  <WarningIcon mt={1} />
                  <Text>
                    Bitte vermeiden Sie USB-Hubs ohne eigene Stromversorgung.
                  </Text>
                </HStack>
                <HStack alignItems={"start"}>
                  <WarningIcon mt={1} />
                  <Text>
                    Falls Ihr Computer keinen USB-C-Anschluss besitzt, verwenden
                    Sie bitte den mitgelieferten USB-C auf USB-A Adapter.
                  </Text>
                </HStack>
              </VStack>
            </MyListItem>
            <MyListItem>
              Sobald das Mikrofon Symbol auf dem Mikrofon grün leuchtet, ist es
              korrekt angeschlossen.
            </MyListItem>
            <Tabs colorScheme="teal">
              <TabList>
                <Tab>Windows</Tab>
                <Tab>macOS</Tab>
              </TabList>
              <TabPanels>
                <TabPanel px={0}>
                  <VStack spacing={2} ml={1} alignItems="unset">
                    <MyListItem>
                      Windows sollte das Mikrofon automatisch erkennen und
                      installieren.
                    </MyListItem>
                  </VStack>
                </TabPanel>
                <TabPanel px={0}>
                  <VStack spacing={2} ml={1} alignItems="unset">
                    <MyListItem>
                      Sobald das Mikrofon angeschlossen ist, sollte macOS es
                      automatisch erkennen. Klicken Sie auf "Erlauben", um das
                      Mikrofon zu verwenden:
                      <Image
                        src={MacOs_AcceptPluggedInDevice}
                        maxWidth="100%"
                        mt={2}
                      />
                    </MyListItem>
                  </VStack>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </VStack>
        </SimpleGrid>
      </Box>

      <Box>
        <TextHeading
          mt={4}
          text={"3. Soundcheck und Inbetriebnahme des Mikrofons"}
        />
        <Tabs colorScheme="teal">
          <TabList>
            <Tab>Windows</Tab>
            <Tab>macOS</Tab>
          </TabList>
          <TabPanels>
            <TabPanel px={0}>
              <VStack spacing={2} ml={1} alignItems="unset">
                <MyListItem>
                  Nachdem Sie das Mikrofon erfolgreich verbunden haben, öffnen
                  Sie <i>Einstellungen &gt; System &gt; Sound</i>.
                </MyListItem>
                <MyListItem>
                  Wählen Sie unter „Eingabe“ das „Shure MV6 USB“ als
                  Standardgerät aus.
                  <Image
                    src={Win_AudioSettings}
                    maxWidth="100%"
                    mb={2}
                    mt={2}
                  />
                </MyListItem>
                <MyListItem>
                  Überprüfen Sie die Lautstärke und Pegelanzeige, um
                  sicherzustellen, dass das Mikrofon korrekt funktioniert.{" "}
                </MyListItem>
                <MyListItem>
                  Sprechen Sie in das Mikrofon und beobachten Sie die
                  Pegelanzeige. Der Pegel sollte bei normaler Sprechlautstärke
                  bis mindestens 50% ausschlagen.
                </MyListItem>
                <MyListItem icon={WarningIcon}>
                  Falls der Pegel zu niedrig ist, erhöhen Sie die
                  Eingangslautstärke:
                  <Image
                    src={Win_AudioSettings_DeviceSettings}
                    maxWidth="100%"
                    mt={2}
                  />
                  <Image src={Win_AudioSettings_Pegel} maxWidth="100%" mt={2} />
                </MyListItem>
              </VStack>
            </TabPanel>
            <TabPanel px={0}>
              <VStack spacing={2} ml={1} alignItems="unset">
                <MyListItem>
                  Nachdem Sie das Mikrofon erfolgreich verbunden haben, öffnen
                  Sie <i>Systemeinstellungen &gt; Ton</i> gehen.
                </MyListItem>
                <MyListItem>
                  Wählen Sie im Tab „Eingabe“ das „Shure MV6 USB“ Mikrofon aus.
                  <Image
                    src={MacOs_AudioSettings}
                    maxWidth="100%"
                    mb={2}
                    mt={2}
                  />
                </MyListItem>

                <MyListItem>
                  Passen Sie die Eingangslautstärke an und kontrollieren Sie die
                  Pegelanzeige.
                  <HStack alignItems={"start"} fontSize={"xs"} mt={2}>
                    <WarningIcon mt={1} />
                    <Text>
                      Die Lautstärke sollte so eingestellt sein, dass der Pegel
                      bei normaler Sprechlautstärke etwa 70–90% ausschlägt.
                    </Text>
                  </HStack>
                </MyListItem>
              </VStack>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

      <Box>
        <TextHeading mt={4} text={"4. Aufnahme des Podcasts"} />
        <VStack spacing={2} ml={1} alignItems="unset">
          <MyListItem icon={InfoOutlineIcon}>
            Sie erhalten per E-Mail einen Link zur Aufnahmeplattform
            „Riverside.fm“.
          </MyListItem>
          <MyListItem icon={InfoOutlineIcon}>
            Klicken Sie auf den Link und melden Sie sich kurz an, um direkt in
            ihre Sitzung zu gelangen.
            <Image src={All_Riverside_Welcome} maxWidth="100%" mb={2} mt={2} />
          </MyListItem>
          <MyListItem>
            Stellen Sie sicher, dass Ihr Mikrofon und Ihre Kamera ordnungsgemäß
            im Browser funktionieren. Sie können dies folgendermaßen überprüfen:{" "}
            <Tabs colorScheme="teal">
              <TabList>
                <Tab>Windows</Tab>
                <Tab>macOS</Tab>
              </TabList>
              <TabPanels>
                <TabPanel px={0}>
                  Geben Sie Ihren Namen ein und klicken auf "Allow Access"
                  <Image
                    src={Win_Riverside_StartAllowAccess}
                    maxWidth="100%"
                    mb={4}
                    mt={2}
                  />
                  Erteilen Sie den Browser Zugriff auf Mikrofon (und Kamera).
                  <Image
                    src={Win_Riverside_AllowAccess}
                    maxWidth="100%"
                    mb={2}
                    mt={2}
                  />
                </TabPanel>
                <TabPanel px={0}>
                  Geben Sie Ihren Namen ein und klicken auf "Allow Access"
                  <Image
                    src={MacOs_Riverside_StartAllowAccess}
                    maxWidth="100%"
                    mb={4}
                    mt={2}
                  />
                  Erteilen Sie den Browser Zugriff auf Mikrofon (und Kamera).
                  <Image
                    src={MacOs_Riverside_AllowAccess}
                    maxWidth="100%"
                    mb={2}
                    mt={2}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>{" "}
            Nun können Sie auf "Join" klicken, um dem Interview beizutreten.
            <Image src={All_Riverside_Join} maxWidth="100%" mb={4} mt={2} />
          </MyListItem>
        </VStack>
      </Box>

      {/*       <Box>
        <TextHeading mt={4} text={"Wichtige Informationen zum Ablauf"} />
        <VStack spacing={2} ml={1} alignItems="unset">
          <MyListItem icon={TimeIcon}>
            Jede Podcast-Folge dauert ca. 15 Minuten; das gesamte Interview
            maximal 30 Minuten.
          </MyListItem>
          <MyListItem icon={TimeIcon}>
            Der vereinbarte Termin dauert insgesamt 60 Minuten, inklusive Vor-
            und Nachbereitung.
          </MyListItem>
          <MyListItem icon={EmailIcon}>
            Die Interviewfragen erhalten Sie im Voraus zur Vorbereitung.
          </MyListItem>
          <MyListItem icon={InfoOutlineIcon}>
            Die fertige Aufnahme wird professionell geschnitten und Ihnen zur
            Freigabe geschickt.
          </MyListItem>
          <MyListItem icon={InfoOutlineIcon}>
            Nach Ihrer Freigabe erfolgt die Veröffentlichung auf Spotify und
            Apple Podcasts.
          </MyListItem>
        </VStack>
      </Box> */}

      <Box>
        <Text mt={4} fontWeight="bold">
          Wir wünschen Ihnen viel Spaß und freuen uns auf eine tolle Aufnahme!{" "}
        </Text>
      </Box>
    </VStack>
  );
};

function MyListItem({
  children,
  icon,
}: {
  children: React.ReactNode | string;
  icon?: React.ElementType;
}): JSX.Element {
  return (
    <HStack alignItems={"start"} spacing={2}>
      <Icon
        as={icon ? icon : CheckCircleIcon}
        color={icon ? "gray.600" : "green.500"}
        mt={1}
      />
      <Text>{children}</Text>
    </HStack>
  );
}
